import { createSelector } from 'reselect';

export * from './selectors.common';

const selectUrlState = (state) => state.url;

export const selectCurrentOrigin = createSelector([selectUrlState], (url) =>
  url.get('origin')
);

export const selectCurrentCustomDomain = createSelector(
  [selectUrlState],
  (url) => url.get('customDomain')
);

export const selectCurrentProtocol = createSelector([selectUrlState], (url) =>
  url.get('protocol')
);

export const selectIsInAppWebview = createSelector([selectUrlState], (url) =>
  url.get('inAppWebview')
);
